import Config from "../config/config";
import { http } from "../index";
import { PostData, query_params } from "../helpers/params";

const Ping = (loader, lang = "ka") => {
  return http.get({
    url: Config.Guest.Ping.replace("{lang}", lang),
    loader: loader,
  });
};

const Alive = () => {
  return http.get({
    url: Config.Guest.Alive,
  });
};

const SignIn = ({ data, loader }) => {
  return http.post({
    url: Config.Guest.SignIn,
    data: PostData(data),
    loader: loader,
  });
};

const Recovery = (params, loader) => {
  return http.post({
    url: Config.Guest.Recovery,
    data: PostData(params),
    loader: loader,
  });
};

const Register = ({ isReferral = false, stage, data, loader }) => {
  let params;
  switch (stage) {
    case 1:
      params = {
        service: "getSms",
        phone_index: data.phoneIndex,
        phone: data.phone,
      };
      break;
    case 2:
      params = {
        service: "getSms",
        phone_index: data.phoneIndex,
        phone: data.phone,
        captcha: data.captcha,
      };
      break;
    case 3:
      params = {
        service: "checkPidPhone",
        pid: data.personalId,
        sms_code: data.sms,
      };
      break;
    case 4:
      params = {
        service: "setUserPassEmail",
        username: data.username,
        email: data.email,
        rules: data.rules,
      };
      if (!isReferral) params.password = data.password;
      break;
  }

  const mode = isReferral ? "referral_reg_api" : "simple_reg_api";
  return http.post({
    url: Config.Guest.Register.replace("{mode}", mode),
    data: PostData(params),
    loader: loader,
  });
};

export default {
  SignIn,
  Ping,
  Recovery,
  Register,
  Alive
};
